import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import Home from './pages/Home';
import About from './pages/About';
import NotFound from './pages/NotFound';
import ProjectShowcase from './pages/ProjectShowcase';
import Layout from './Layout';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='*' element={<NotFound />} />
          <Route path='/project-showcase/:id' element={<ProjectShowcase />} />
          <Route path='/about' element={<About />} />
          <Route path='/404' element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
